export default "__VITE_ASSET__BEch$U10__"